// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
import { ToolbarItem } from './ToolbarItem';
/**
 * Represents the Kendo UI for Vue Toolbar Separator component.
 */

var ToolbarSeparatorVue2 = {
  name: 'KendoToolbarItem',
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },
  render: function render(createElement) {
    var h = gh || createElement;
    return (// @ts-ignore
      h(ToolbarItem, {
        "class": "k-separator"
      })
    );
  }
};
var ToolbarSeparator = ToolbarSeparatorVue2;
export { ToolbarSeparator, ToolbarSeparatorVue2 };